import React from 'react';
import styled from 'styled-components';

const descriptions = {
  38297: "We​ ​accompany​ ​our​ ​customers​ ​every​ ​step​ ​of​ ​the​ ​way​ ​from​ ​the​ ​moment​ ​they​ ​partner​ ​with​ ​us​ ​to​ ​the end​ ​of​ ​their​ ​journey.​ ​We​ ​bring​ ​passion​ ​to​ ​what​ ​we​ ​do​ ​every​ ​day​ ​because​ ​what​ ​we​ ​do​ ​matters​ ​to real​ ​people.​ ​We​ ​share​ ​happy​ ​and​ ​sad​ ​moments​ ​with​ ​our​ ​customers,​ ​we​ ​laugh​ ​and​ ​cry​ with​ them, and​ ​we​ ​build​ relationships​ ​that​ ​go​ ​far​ ​beyond​ ​a​ ​business​ ​partnership.​ We​ ​are​ ​a​ ​group​ of ambitious,​ ​intelligent,​ ​hard-working,​ ​and​ ​fun​ ​people.​ If​ you ​are​ ​passionate​ ​about​ ​helping​ ​real​ ​hard working​ ​people,​ ​love​ ​technology,​ ​aren't​ afraid​ ​of​ ​a​ ​challenge​ ​or​ ​two,​ ​and​ have​ ​a​ ​desire​ ​to​ ​push yourself​ ​to​ ​your​ ​maximum​ ​potential,​ ​our​ CS​ ​team​ ​is​ ​where​ ​you​ ​belong.",
  Engineering:
    'You will be part of the Engineering team at ServiceTitan to help improve our products and building new ones. We provide exciting opportunities engineers to come in and develop the major features in the rapidly growing startup. We build for perfection, use the most modern tools on Microsoft .NET platform, have an amazing culture, and love to solve complex problems.',
  38306: 'Our​ ​Executive​ ​Office​ ​is​ ​the​ ​driving​ ​force​ ​behind​ ​all​ ​major​ ​decisions,​ ​communications,​ ​and execution​ ​across​ ​the​ ​entire​ ​company.​ ​This​ ​team​ ​works​ ​very​ ​closely​ ​with​ ​all​ ​department​ ​heads​ ​as well​ ​as​ ​external​ ​partners​ ​to​ ​facilitate​ ​the​ ​flow​ ​of​ ​information​ ​and​ ​escalation,​ ​inspire​ ​innovative solution-engineering,​ ​and​ ​resolve​ ​the​ ​toughest​ ​roadblocks​ ​to​ ​our​ ​organizational​ ​success. Members​ ​of​ ​the​ ​Executive​ ​Office​ ​come​ ​from​ ​very​ ​diverse​ ​backgrounds,​ ​with​ ​a​ ​broad​ ​set​ ​of​ ​skills  and​ ​knowledge,​ ​that​ ​enable​ ​them​ ​to​ ​react​ ​quickly​ ​and​ ​effectively​ ​to​ ​any​ ​challenge​ ​being​ ​raised.',
  38300: 'Our​ ​Finance​ ​and​ ​Operations​ ​team​ ​is​ ​a​ ​dynamic,​ ​relatively​ ​small​ ​group,​ ​that​ ​produces​ ​super​ ​high quality​ ​output.​ ​We​ ​have​ ​built​ ​a​ ​world​ ​class,​ ​fully​ ​automated​ ​and​ ​integrated​ ​SaaS​ ​financial​ ​and reporting​ ​infrastructure,​ ​that​ ​allows​ ​us​ ​to​ ​move​ ​quickly,​ ​with​ ​a​ ​high​ ​degree​ ​of​ ​accuracy​ ​and  predictability.​ ​Unlike​ ​traditional​ ​companies,​ ​where​ ​finance​ ​teams​ ​are​ ​typically​ ​the​ ​police​ ​cops​ ​and nay-sayers,​ ​we​ ​are​ ​a​ ​team​ ​that​ ​tries​ ​to​ ​say​ ​"yes"​ ​first.​ ​How​ ​can​ ​we​ ​help​ ​solve​ ​your​ ​problem?​ ​How will​ ​this​ ​investment​ ​improve​ ​our​ ​business?​ ​We​ ​are​ ​a​ ​dedicated,​ ​hard​ ​working​ ​team,​ ​quick​ ​to​ ​have fun,​ ​and​ ​we​ ​enjoy​ ​our​ ​amazing​ ​culture!',
  Marketing:
    'ServiceTitan​ ​is​ ​a​ ​product​ ​built​ ​by​ ​the​ ​intellect,​ ​passion​ ​and​ ​vision​ ​of​ ​hundreds​ ​of​ ​people.​ ​We wake​ ​up​ ​every​ ​day​ ​driven​ ​to​ ​offer​ ​the​ ​finest​ ​SaaS​ ​tools​ ​to​ ​hard-working,​ ​home​ ​service  professionals​ ​who​ ​have​ ​been​ ​completely​ ​underserved​ ​by​ ​technology.​ ​To​ ​be​ ​a​ ​marketer​ ​at  ServiceTitan​ ​is​ ​to​ ​carry​ ​that​ ​fire​ ​into​ ​the​ ​world.​ ​We​ ​are​ ​passionate​ ​about​ ​content​ ​and​ ​driven​ ​by  data.​ ​We​ ​mine​ ​collective​ ​experience​ ​and​ ​stoke​ ​unyielding​ ​curiosity​ ​to​ ​uncover​ ​the​ ​channels​ ​and  creative​ ​that​ ​will​ ​deliver​ ​ServiceTitan’s​ ​life-changing​ ​power​ ​to​ ​every​ ​potential​ ​customer.',
  'People Operations':
    'Build​ ​a​ ​high-performing​ ​team.​ ​Our​ ​People​ ​Operations​ ​team​ ​achieves​ ​this​ ​mission​ ​by​ ​recruiting the​ ​right​ ​talent,​ ​equipping​ ​them​ ​with​ ​the​ ​right​ ​resources​ ​to​ ​make​ ​an​ ​impact,​ ​and​ ​growing​ ​our Titans​ ​into​ ​the​ ​right​ ​career​ ​paths​ ​that​ ​best​ ​match​ ​their​ ​individual​ ​talents​ ​and​ ​interests.​ ​We​ ​are united​ ​in​ ​our​ ​passion​ ​and​ ​desire​ ​to​ ​unlock​ ​the​ ​extraordinary​ ​potential​ ​of​ ​every​ ​single​ ​person​ ​in  our​ ​organization:​ ​so​ ​that​ ​we​ ​may​ ​lose,​ ​learn,​ ​and​ ​win​ ​as​ ​a​ ​team.​ ​Every​ ​day​ ​is​ ​an​ ​opportunity​ ​for change;​ ​and​ ​for​ ​our​ ​People​ ​Operations​ ​team​ ​-​ ​it​ ​is​ ​an​ ​opportunity​ ​to​ ​make​ ​a​ ​positive​ ​difference​ ​in the​ ​employee​ ​lives​ ​we​ ​touch.',
  Product:
    'We​ ​solve​ ​real​ ​world​ ​problems​ ​in​ ​the​ ​home​ ​services​ ​industry.​ ​We​ ​are​ ​passionate​ ​about​ ​bringing innovative​ ​and​ ​delightful​ ​solutions​ ​to​ ​traditional​ ​problems​ ​and​ ​workflows.​ ​Our​ ​ambitious​ ​team​ ​of product​ ​managers,​ ​designers,​ ​and​ ​product​ ​marketers​ ​works​ ​closely​ ​with​ ​our​ ​thousands​ ​of​ ​users to​ ​help​ ​make​ ​their​ ​lives​ ​easier​ ​through​ ​technology.​ ​We​ ​embrace​ ​agile​ ​development​ ​and​ ​design thinking​ ​to​ ​ship​ ​hundreds​ ​of​ ​new​ ​features​ ​every​ ​month.​ ​We​ ​measure​ ​our​ ​success​ ​based​ ​on​ ​our customer’s​ ​success.​ ​We​ ​strive​ ​for​ ​real​ ​impact.',
  Sales:
    'Our​ ​Sales​ ​team​ ​is​ ​a​ ​turbocharged​ ​V12​ ​engine​ ​that​ ​drives​ ​the​ ​entire​ ​company​ ​forward​ ​by​ ​bringing  our​ ​software​ ​platform​ ​to​ ​new​ ​customers​ ​-​ ​every​ ​single​ ​day.​ ​We​ ​are​ ​a​ ​tight-knit,​ ​high-energy​ ​crew that​ ​comprises​ ​Sales​ ​Development,​ ​Account​ ​Executives,​ ​and​ ​Sales​ ​Operations.​ ​We​ ​have​ ​a​ ​shared  passion​ ​for​ ​helping​ ​residential​ ​contractors​ ​take​ ​their​ ​business​ ​to​ ​the​ ​next​ ​level,​ ​and​ ​nothing  makes​ ​our​ ​team​ ​happier​ ​than​ ​seeing​ ​stellar​ ​feedback​ ​from​ ​customers​ ​who​ ​have​ ​had​ ​the  opportunity​ ​to​ ​leverage​ ​ServiceTitan.',
  43226: 'We formulate, build, launch and run new ServiceTitan business lines.  The team at Platform & Payments is integral to the success of ServiceTitan’s valued customers, as we enable process improvement through technology integrations with key ServiceTitan partners.  We build cutting edge solutions in Financial Technology (FinTech), Internet of Things (IoT), etc. to empower contractors to take the next leap forward in streamlining technician interactions with the homeowner.  Think of us as a start-up within a start-up.  We are extremely ambitious in expanding revenue and contributing to the overall company growth.  We are looking for talented and passionate future Titans that are entrepreneurial, love technology and want to help our customers maximize their potential.',
  Growth:
    'Growth is a highly strategic team responsible for assessing, validating, building and launching new business opportunities to accelerate growth at ServiceTitan while making a massive positive impact to our customers.  We want to build innovative products, provide extraordinary services & become the premier brand in the home services industry.',
};

const JobPostsMarketingSection = ({ background, title, description, jobCards, ...otherProps }) => {
  return (
    <SectionContainer background={background} {...otherProps}>
      <div className="section-job-posts-marketing--wrapper" id="job-section">
        <div className="section-job-posts-marketing--container">
          <div className="section-job-posts-marketing--text-content">
            <h2 className="section-job-posts-marketing--title">{title}</h2>
            <p className="section-job-posts-marketing--description">{descriptions[title]}</p>
          </div>
          <div className="section-job-posts-marketing--card-content">
            {jobCards?.map((cardItem, index) => {
              return (
                <a
                  className="section-job-posts-marketing--card-container"
                  href={cardItem.absolute_url}
                  target="_blank"
                  key={index}
                >
                  <h2 className="section-job-posts-marketing--card-title">{cardItem.title}</h2>
                  <p className="section-job-posts-marketing--card-description">
                    {cardItem.locations.map(x => (
                      <div>{x.locationName}</div>
                    ))}
                  </p>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  background: white;

  &:last-child {
    .section-job-posts-marketing--container {
      border-bottom: none;
    }
  }

  .section-job-posts-marketing--wrapper {
    background: ${props => props.background};
    padding: 0 28px;
  }

  .section-job-posts-marketing--container {
    border-bottom: 1px solid #cfd8dc;
    margin: 28px auto 0;
    padding: 20px 0;
    max-width: 1252px;
    display: flex;

    .section-job-posts-marketing--text-content {
      width: 333px;
      min-width: 333px;
      padding-top: 20px;

      .section-job-posts-marketing--title {
        font-size: 31px;
        font-weight: 900;
        line-height: 110%;
        letter-spacing: -0.03em;
        color: var(--black-color);
        margin: 0 auto;
      }

      .section-job-posts-marketing--description {
        font-size: 16px;
        font-weight: 500;
        line-height: 150%;
        color: var(--black-color);
        margin: 30px auto 30px;
      }
    }

    .section-job-posts-marketing--card-content {
      padding-left: 80px;
      width: 100%;

      .section-job-posts-marketing--card-container {
        margin: 0 auto 30px;
        padding: 27px 35px;
        background: var(--neutral-1);
        display: block;

        .section-job-posts-marketing--card-title {
          font-weight: bold;
          font-size: 20px;
          line-height: 120%;
          letter-spacing: -0.01em;
          color: var(--black-color);
        }

        .section-job-posts-marketing--card-description {
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          color: var(--neutral-text-color);
          margin: 8px 0 0;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-job-posts-marketing--wrapper {
      padding: 0;
    }

    .section-job-posts-marketing--container {
      margin: 0 auto;
      padding: 30px 0;

      .section-job-posts-marketing--text-content {
        flex: 5;
        min-width: 0;
        padding: 35px 21px 20px;

        .section-job-posts-marketing--title {
          font-size: 23px;
        }

        .section-job-posts-marketing--description {
          font-size: 16px;
          margin-top: 20px;
        }
      }

      .section-job-posts-marketing--card-content {
        flex: 5;
        padding: 25px 21px 20px;

        .section-job-posts-marketing--card-container {
          margin-bottom: 10px;
          padding: 20px;

          .section-job-posts-marketing--card-title {
            font-size: 18px;
            line-height: 120%;
          }

          .section-job-posts-marketing--card-description {
            margin-top: 10px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-job-posts-marketing--container {
      margin: 0 auto;
      padding-bottom: 0;
      flex-direction: column;

      .section-job-posts-marketing--text-content {
        padding: 15px 20px 0;
        width: 100%;
      }

      .section-job-posts-marketing--card-content {
        width: 100%;
        padding-top: 10px;
      }
    }
  }
`;

export default JobPostsMarketingSection;
